var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRotateLeftTool = function SvgRotateLeftTool(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_rotate_left)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 10.686,
    y: 8.79004,
    width: 17,
    height: 15,
    rx: 3,
    transform: "rotate(5 10.686 8.79004)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.00007 14C5.00007 9 9.00007 4 15.0001 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_rotate_left)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.26297 12H5.73703C4.09201 12 3.2695 12 2.98684 12.5281C2.70419 13.0563 3.16044 13.7407 4.07293 15.1094L4.3359 15.5038C5.08851 16.6328 5.46482 17.1972 6 17.1972C6.53518 17.1972 6.91149 16.6328 7.6641 15.5038L7.92707 15.1094C8.83956 13.7407 9.29581 13.0563 9.01316 12.5281C8.7305 12 7.90799 12 6.26297 12Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_rotate_left",
    x: -0.0964355,
    y: 10,
    width: 12.1927,
    height: 11.1972,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_rotate_left"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRotateLeftTool);
export { ForwardRef as ReactComponent };